module.exports = __webpack_public_path__ + "media/images/help/flow/bg-rail-03-86eda39031a1bc1e3351b83c96ce5abc.svg";